import { Action } from '@ngrx/store';
import { UserDetailsApiDto } from './models/user-details-api-dto';
import { UserBranchDetailsApiDto } from './models/user-branch-details-api-dto';

export enum UserDetailsTypes {
  LoadCurrentUser = '[User Details] Load Current User',
  LoadCurrentUserSuccess = '[User Details] Load Current User Success',
  LoadCurrentUserFailed = '[User Details] Load Current User Failed',
  ResetCurrentUser = '[User Details] Reset Current User',
  LoadBranches = '[User Details] Load Branches',
  LoadBranchesSuccess = '[User Details] Load Branches Success',
  LoadBranchesFailed = '[User Details] Load Branches Failed',
  UpdateBranch = '[User Details] Update Branch'
}

export class LoadCurrentUser implements Action {
  public readonly type = UserDetailsTypes.LoadCurrentUser;
}

export class LoadCurrentUserSuccess implements Action {
  public readonly type = UserDetailsTypes.LoadCurrentUserSuccess;

  constructor(public currentUser: UserDetailsApiDto) { }
}

export class LoadCurrentUserFailed implements Action {
  public readonly type = UserDetailsTypes.LoadCurrentUserFailed;

  constructor(public error: string) { }
}

export class ResetCurrentUser implements Action {
  public readonly type = UserDetailsTypes.ResetCurrentUser;
}

export class LoadBranches implements Action {
  public readonly type = UserDetailsTypes.LoadBranches;
}

export class LoadBranchesSuccess implements Action {
  public readonly type = UserDetailsTypes.LoadBranchesSuccess;

  constructor(public payload: UserBranchDetailsApiDto[]) { }
}

export class LoadBranchesFailed implements Action {
  public readonly type = UserDetailsTypes.LoadBranchesFailed;

  constructor(public error: string) { }
}

export class UpdateBranch implements Action {
  public readonly type = UserDetailsTypes.UpdateBranch;

  constructor(public customerId: string) { }
}

export type UserDetailsUnion =
  | LoadCurrentUser
  | LoadCurrentUserSuccess
  | LoadCurrentUserFailed
  | ResetCurrentUser
  | LoadBranches
  | LoadBranchesSuccess
  | LoadBranchesFailed
  | UpdateBranch;
